import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import useScrollReveal from '../hooks/useScrollReveal';
import { ClickSpark } from '../reactbits';
import { useLanguage } from '../context/LanguageContext';
import { prefetchMarketPulse } from '../api';
export default function Layout({ children }) {
  const location = useLocation();
  const { lang } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 400));
    const cancel = window.cancelIdleCallback || clearTimeout;
    const handle = idle(() => prefetchMarketPulse(lang));
    return () => cancel(handle);
  }, [lang]);

  useScrollReveal(`${location.pathname}::${lang}`);

  return (
    <ClickSpark sparkColor="#0e7c72" sparkCount={8} sparkRadius={17} duration={430}>
      <a href="#main" className="skip-link">Skip to content</a>
      <Header />
      <main id="main" key={lang}>{children}</main>
      <Footer />
    </ClickSpark>
  );
}
